export default __webpack_public_path__ + "static/media/zeroq-color.68d6fc6e.svg";